import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { Button } from "../components/ui/button";
import { ProcessedCard } from "../components/processed-card";
import { RootState } from "../../store/store";
import { BackButton } from "../components/back-button";

export function KeyTermProcessed() {
	const navigate = useNavigate();
	const { keyTermIdx } = useParams();

	const keyTerms = useSelector((state: RootState) => state.analysis.processed);

	if (keyTerms.risks.length <= Number(keyTermIdx)) {
		navigate("/processed");
		return null;
	}

	const keyTerm = keyTerms.risks.at(Number(keyTermIdx));

	return (
		<div className="px-2 py-4">
			<BackButton />

			<div className="flex items-center justify-between mt-2">
				<h1 className="text-lg font-bold">{keyTerm.key.replace(/\s*\(\d+\)$/, "")}</h1>
			</div>

			<div className="rounded-lg px-3 py-0.5 grid w-fit justify-center items-center text-xs bg-orange-50 text-orange-500">
				{keyTerm.values.at(0).comparison_type.at(0).toUpperCase() + keyTerm.values.at(0).comparison_type.slice(1)}
			</div>

			<div className="pb-20">
				{keyTerm.values.map(({ risk_id }, idx) => (
					<ProcessedCard key={risk_id} keyTermIdx={Number(keyTermIdx)} mitigationIdx={idx} />
				))}
			</div>

			<div className="fixed bottom-0 left-14 right-0 bg-white border-t-2 px-3 py-2">
				<div className="grid grid-cols-2 gap-3">
					<Button
						size="sm"
						variant="outline"
						disabled={Number(keyTermIdx) === 0}
						onClick={() => navigate(`/processed/${Number(keyTermIdx) - 1}`)}
					>
						Previous
					</Button>
					<Button
						size="sm"
						disabled={Number(keyTermIdx) === keyTerms.risks.length - 1}
						className="disabled:cursor-not-allowed"
						onClick={() => navigate(`/processed/${Number(keyTermIdx) + 1}`)}
					>
						Next
					</Button>
				</div>
			</div>
		</div>
	);
}
